import { render, staticRenderFns } from "./DetailTaskTemplate.vue?vue&type=template&id=87c36476"
import script from "./DetailTaskTemplate.vue?vue&type=script&lang=js"
export * from "./DetailTaskTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports